import React from 'react';
import {
    Datagrid,
    DateField,
    TextField,
    Filter,
    List,
    SearchInput,
} from 'react-admin';

import FullNameField from '../fields/users/FullNameField';

const UserFilter = (props: any) => (
    <Filter {...props}>
        <SearchInput source="q" alwaysOn />
    </Filter>
);

const exporter = async (users: any) => {
    try {
        // Call the server endpoint
        const response = await fetch(
            `${process.env.REACT_APP_ADMIN_REST_API_URL}/users/export/excel`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            }
        );

        if (!response.ok) {
            throw new Error('Export failed');
        }

        // Extract filename from Content-Disposition header
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = `Users-${Date.now()}.xlsx`; // Default fallback

        if (contentDisposition) {
            // Try to extract filename from Content-Disposition header
            // Handles both: filename="file.xlsx" and filename*=UTF-8''file.xlsx
            const filenameMatch = contentDisposition.match(
                /filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/i
            );
            if (filenameMatch && filenameMatch[1]) {
                filename = decodeURIComponent(filenameMatch[1]);
            }
        }

        // Get the blob from response
        const blob = await response.blob();

        // Create download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Error exporting users:', error);
        alert('Failed to export users. Please try again.');
    }
};

const UserList = (props: any) => {
    return (
        <List
            {...props}
            filters={<UserFilter />}
            sort={{ field: 'created_at', order: 'DESC' }}
            perPage={10}
            bulkActionButtons={false}
            exporter={exporter}
        >
            <Datagrid optimized rowClick="edit">
                <DateField
                    source="created_at"
                    type="date"
                    label="resources.users.fields.created_at"
                    showTime
                    options={{
                        hourCycle: 'h23',
                    }}
                />
                <TextField
                    source="civility"
                    label="resources.users.fields.civility"
                />
                <FullNameField
                    source="name"
                    label="resources.users.fields.name"
                />
                <TextField
                    source="phone"
                    label="resources.users.fields.phone"
                />
                <TextField
                    source="email"
                    label="resources.users.fields.email"
                />
            </Datagrid>
        </List>
    );
};

export default UserList;
